import React, { Component } from "react";
import { Button,Form,Icon,Grid } from "tabler-react";
import { GetRoles } from "../../herramientas/JWT";
import { Crud_Catalogos } from '../../herramientas/Crud_Catalogos';
class  CanalesForm extends Component {
  constructor(props) {
    super(props);
    this.state = {  canal:       1,
                    nombre:      "",
                    descripcion: "",                        
                    accion: this.props.accion, //'nuevo'// modificar, nuevo
                    crudbutonEnable: true, // Se desabilita cuando se hace click
                  };
    this.objeto={
      "idDispositivo": this.props.dispositivo.id,
      "canal": 1,
      "nombre": "Cabina",
      "descripcion": "Cabina"
    };
  }
  componentDidMount =() => {
    if(this.state.accion !== 'nuevo'){
      this.setState({canal: this.props.elemento.canal});
      this.setState({nombre: this.props.elemento.nombre});
      this.setState({descripcion: this.props.elemento.descripcion});
      this.objeto= this.props.elemento;
    }
  }
  enableSave =() =>{
    if(this.state.canal && this.state.nombre.length && this.state.descripcion.length )
      return false;
    else
      return true
  }
  changeCanal =(event) => {
    this.setState({canal: event.target.value});
    this.objeto.canal= event.target.value;
  }
  changeNombre =(event) => {
    this.setState({nombre: event.target.value});
    this.objeto.nombre= event.target.value;
  }
  changeDescripcion = (event) =>{
    this.setState({descripcion: event.target.value});
    this.objeto.descripcion= event.target.value;
  }

  delete() {
    this.setState({ crudbutonEnable: false });
    Crud_Catalogos(this.props.catalogo, "delete", "", this.objeto.idDispositivo+"/"+this.objeto.canal).then((returnVal) => {
      window.location.reload();
    }).catch(err =>{ alert("A ocurrido un error")});
  }
  save(metodo= "post") {
    this.setState({ crudbutonEnable: false });
    Crud_Catalogos(this.props.catalogo, metodo, this.objeto, "").then((returnVal) => {
      //window.location.reload();
    }).catch(err =>{ alert("A ocurrido un error")});
  }
  

  render(){
    return (
      <div>
        { this.state.accion === "modificar" ? <h1> { this.props.elemento.nombre } </h1> : null }
        <Grid.Row>
          <Grid.Col md={12} xl={12}>
            <Grid.Row>
              <Grid.Col md={9} lg={9}>
                <Form.Group label="Canal">
                  <Form.Input name="canal" type="number" value={ this.state.canal } onChange={ this.changeCanal } />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={9} lg={9}>
                <Form.Group label="Nombre">
                  <Form.Input name="nombre" type="text" value={ this.state.nombre } onChange={this.changeNombre} maxlength="30" />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={6} lg={6}>
                <Form.Group label="Descripcion">
                  <Form.Textarea name="descripcion" type="text" value={ this.state.descripcion } onChange={this.changeDescripcion} maxlength="255"/>
                </Form.Group>
              </Grid.Col>
           </Grid.Row>
          </Grid.Col>
        </Grid.Row>
        <div className="float-right">
          {GetRoles().includes("root") ?
            <span class="badge">
                <Button target="_blank" size="sm" RootComponent="a" color="primary" disabled= { this.enableSave() || !this.state.crudbutonEnable }
                  onClick= { this.state.accion === "modificar" ? () => this.save("put") : () => this.save("post") }
                >
                  <span class="badge"><Icon link={true} name="save" />Guardar</span>
                </Button>
            </span>
          :null}
          { GetRoles().includes("root")  ?
            <span class="badge">
              <Button target="_blank" size="sm" RootComponent="a" color="primary"
                onClick= { () => this.delete() } disabled={!this.state.crudbutonEnable}
              >
                <span class="badge"><Icon link={true} name="trash" />Borrar</span>
              </Button>
            </span>
          :
          null
          }
        </div>
      </div>
    );
  }
}
export default CanalesForm;
